// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"06140e42","453":"0feb56a7","455":"14ba3a83"}[chunkId] + ".chunk.js";
};